import React, { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { Tooltip } from 'antd';
import Icon from '@ant-design/icons';
import OpenOutIcon from '@icons/common/open-out.svg';
import { panelsAtom } from '../atoms';
import NetworkTable from './table';
import ErrorBoundary from '../../common/Retry/ErrorBoundary';
import {
  NetworkDashboardWrapper,
  NetworkWrapper,
  PanelHeader,
  PanelTitle,
  DrilldownIconButton,
} from './styled';
const { baseUrl } = window.conviva;

const NetworkPanel = () => {
  const panels = useAtomValue(panelsAtom);

  const handleOpenPreset = useCallback(() => {
    window.open(`${baseUrl}/dashboard/preset/network-performance`, '_blank', 'noopener,noreferrer');
  }, []);

  return (
    <ErrorBoundary>
      <NetworkDashboardWrapper style={{ display: panels.network ? 'block' : 'none' }}>
        <NetworkWrapper>
          <PanelHeader>
            <PanelTitle>Service Performance</PanelTitle>
            <Tooltip title="Open Service Performance preset" placement="top">
              <DrilldownIconButton
                size="small"
                icon={<Icon component={OpenOutIcon} />}
                type="text"
                onClick={handleOpenPreset}
              />
            </Tooltip>
          </PanelHeader>
          <NetworkTable />
        </NetworkWrapper>
      </NetworkDashboardWrapper>
    </ErrorBoundary>
  );
};

export default NetworkPanel;
